import { inject, Injectable } from '@angular/core';
import { GeogebraApi } from '../+api/models';
import { GeogebraSessionInterface } from '../+models';
import { GeogebraServiceInterface } from './geogebra.service.interface';

@Injectable({
  providedIn: 'root',
})
export class GeogebraService implements GeogebraServiceInterface {
  private geogebraApi: GeogebraApi = inject(GeogebraApi);

  public upsertGeogebraSession(ggbSession: GeogebraSessionInterface) {
    return this.geogebraApi.upsertGeogebra(ggbSession);
  }
}
